import { render, staticRenderFns } from "./FactAddProd.vue?vue&type=template&id=bec64472&scoped=true&"
import script from "./FactAddProd.vue?vue&type=script&lang=js&"
export * from "./FactAddProd.vue?vue&type=script&lang=js&"
import style0 from "./FactAddProd.vue?vue&type=style&index=0&id=bec64472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec64472",
  null
  
)

export default component.exports